/* TheSalonGuy conversion homepage — Ajax cart, routine builder, cart drawer sync, bag bar, count-up. */
(function () {
  if (window.__tsgc) return;
  window.__tsgc = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var lastCart = null;

  /* ---------- Helpers ---------- */
  function drawer() {
    return document.querySelector('cart-drawer#cart-drawer') || document.querySelector('cart-drawer');
  }

  function drawerSectionId() {
    var d = drawer();
    var wrap = d && d.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function moneyFormat() {
    var bar = document.querySelector('[data-tsgc-bagbar]');
    return (bar && bar.dataset.moneyFormat) ||
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      '${{amount}}';
  }

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    var fmt = moneyFormat();
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; return cart; });
  }

  function addItems(items) {
    var body = { items: items };
    var sid = drawerSectionId();
    if (sid) {
      body.sections = [sid];
      body.sections_url = window.location.pathname;
    }
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error(data.description || data.message || 'Could not add to bag');
          err.status = r.status;
          throw err;
        }
        return data;
      });
    });
  }

  function shippingProgress(cart) {
    var bar = document.querySelector('[data-tsgc-bagbar]');
    var threshold = bar ? Number(bar.dataset.threshold) : 6500;
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.requires_shipping) total += item.final_line_price;
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      total -= d.total_allocated_amount || 0;
    });
    var remaining = Math.max(0, threshold - total);
    var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
    return { remaining: remaining, pct: pct };
  }

  /* ---------- Cart drawer sync ---------- */
  function stampOf(cart) { return cart.item_count + '-' + cart.total_price; }

  function replaceDrawerFromHtml(html, cart) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('cart-drawer');
    if (!fresh) return;
    d.replaceChildren.apply(d, Array.prototype.map.call(fresh.childNodes, function (n) { return document.importNode(n, true); }));
    d.classList.toggle('drawer--center-body', cart.item_count === 0);
  }

  function syncAddonFromHtml(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('cart-drawer [data-tsgc-addon]');
    var current = d.querySelector('[data-tsgc-addon]');
    var freshStamp = doc.querySelector('cart-drawer [data-tsgc-cart-stamp]');
    var currentStamp = d.querySelector('[data-tsgc-cart-stamp]');
    if (freshStamp && currentStamp) currentStamp.dataset.tsgcCartStamp = freshStamp.dataset.tsgcCartStamp;
    if (current && fresh) current.replaceWith(document.importNode(fresh, true));
    else if (current && !fresh) current.remove();
    else if (!current && fresh) {
      var items = d.querySelector('.cart-drawer__items');
      if (items) items.after(document.importNode(fresh, true));
    }
  }

  // Render the drawer for the CURRENT page (not the homepage), so page-specific rules apply —
  // e.g. no add-on form on Sesami consult pages.
  function fetchDrawerHtml() {
    var sid = drawerSectionId();
    if (!sid) return Promise.resolve(null);
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }

  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = ROOT + 'cart'; return; }
    if (typeof d.show === 'function') d.show();
    else d.setAttribute('open', '');
  }

  function announce(cart, sections) {
    var sid = drawerSectionId();
    var detailCart = Object.assign({}, cart, { sections: sections || {} });
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: detailCart, tsgc: true }
    }));
    // If the theme did not re-render the drawer, do it here.
    return new Promise(function (resolve) {
      setTimeout(function () {
        var d = drawer();
        var stamp = d && d.querySelector('[data-tsgc-cart-stamp]');
        if (d && (!stamp || stamp.dataset.tsgcCartStamp !== stampOf(cart))) {
          var html = sections && sid ? sections[sid] : null;
          (html ? Promise.resolve(html) : fetchDrawerHtml()).then(function (h) {
            replaceDrawerFromHtml(h, cart);
            resolve();
          });
        } else {
          resolve();
        }
      }, 120);
    });
  }

  function afterAdd(data) {
    return getCart().then(function (cart) {
      return announce(cart, data && data.sections).then(function () {
        updateCounts(cart);
        updateBagBar(cart);
        updateRoutines(cart);
        openDrawer();
        return cart;
      });
    });
  }

  function updateCounts(cart) {
    document.querySelectorAll('cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  // Keep our add-on suggestion in step with quantity changes made inside the theme drawer.
  function onAnyCartChange(event) {
    var detail = event && event.detail;
    if (detail && detail.tsgc) return;
    setTimeout(function () {
      var cart = detail && detail.cart && typeof detail.cart.item_count === 'number' ? detail.cart : null;
      (cart ? Promise.resolve(cart) : getCart()).then(function (c) {
        lastCart = c;
        updateBagBar(c);
        updateRoutines(c);
        var d = drawer();
        var stamp = d && d.querySelector('[data-tsgc-cart-stamp]');
        if (d && (!stamp || stamp.dataset.tsgcCartStamp !== stampOf(c))) {
          var sid = drawerSectionId();
          var html = cart && cart.sections && sid ? cart.sections[sid] : null;
          (html ? Promise.resolve(html) : fetchDrawerHtml()).then(syncAddonFromHtml);
        }
      });
    }, 250);
  }
  document.addEventListener('cart:change', onAnyCartChange);

  /* ---------- Buttons ---------- */
  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function flashAdded(button, text) {
    if (!button) return;
    var original = button.innerHTML;
    button.classList.add('is-added');
    button.textContent = text || 'Added';
    setTimeout(function () {
      button.classList.remove('is-added');
      button.innerHTML = original;
    }, 1800);
  }

  function showMessage(form, text, isError) {
    var msg = form.querySelector('.tsgc-add__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('is-error', !!isError);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !window.fetch) return;

    if (form.hasAttribute('data-tsgc-add')) {
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      var id = Number(form.querySelector('[name="id"]').value);
      showMessage(form, '');
      setBusy(button, true);
      addItems([{ id: id, quantity: 1 }])
        .then(afterAdd)
        .then(function () { setBusy(button, false); flashAdded(button, 'Added'); })
        .catch(function (err) {
          setBusy(button, false);
          showMessage(form, err.message, true);
        });
      return;
    }

    if (form.hasAttribute('data-tsgc-routine')) {
      event.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (form.dataset.inBag === 'true') { openDrawer(); return; }
      var ids = form.dataset.tsgcRoutine.split(',').map(Number).filter(Boolean);
      showMessage(form, '');
      setBusy(btn, true);
      getCart()
        .then(function (cart) {
          var inCart = {};
          cart.items.forEach(function (item) { inCart[item.variant_id] = true; });
          var items = ids.filter(function (v) { return !inCart[v]; }).map(function (v) { return { id: v, quantity: 1 }; });
          if (!items.length) return { sections: null, nothingToAdd: true };
          return addItems(items).catch(function (err) {
            // One item failed (often stock). Add the rest one by one and report what was skipped.
            if (err.status !== 422) throw err;
            var skipped = 0;
            var lastData = null;
            return items.reduce(function (chain, item) {
              return chain.then(function () {
                return addItems([item]).then(function (d) { lastData = d; }).catch(function () { skipped += 1; });
              });
            }, Promise.resolve()).then(function () {
              if (skipped) showMessage(form, skipped + (skipped === 1 ? ' product is' : ' products are') + ' out of stock right now. We added the rest.', true);
              if (!lastData) throw err;
              return lastData;
            });
          });
        })
        .then(function (data) {
          if (data && data.nothingToAdd) {
            return getCart().then(function (cart) { updateRoutines(cart); openDrawer(); });
          }
          return afterAdd(data);
        })
        .then(function () { setBusy(btn, false); if (lastCart) updateRoutines(lastCart); })
        .catch(function (err) {
          setBusy(btn, false);
          showMessage(form, err.message, true);
        });
    }
  });

  // Bag links (mobile bar) open the theme drawer instead of the cart page.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-tsgc-open-bag]');
    if (!link || !drawer()) return;
    event.preventDefault();
    openDrawer();
  });

  /* ---------- Routine "already in bag" state ---------- */
  function updateRoutines(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[item.variant_id] = true; });
    document.querySelectorAll('form[data-tsgc-routine]').forEach(function (form) {
      var ids = form.dataset.tsgcRoutine.split(',').map(Number).filter(Boolean);
      var all = ids.length > 0 && ids.every(function (v) { return inCart[v]; });
      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.classList.contains('is-busy')) return;
      if (all && form.dataset.inBag !== 'true') {
        form.dataset.inBag = 'true';
        if (!btn.dataset.tsgcOriginal) btn.dataset.tsgcOriginal = btn.innerHTML;
        btn.textContent = btn.dataset.tsgcInbag || 'View bag';
        btn.classList.add('tsgc-btn--light');
        var title = form.closest('.tsgc-summary') && form.closest('.tsgc-summary').querySelector('[data-tsgc-routine-title]');
        if (title) { title.dataset.tsgcOriginal = title.dataset.tsgcOriginal || title.textContent; title.textContent = 'This routine is in your bag.'; }
      } else if (!all && form.dataset.inBag === 'true') {
        form.dataset.inBag = 'false';
        if (btn.dataset.tsgcOriginal) btn.innerHTML = btn.dataset.tsgcOriginal;
        btn.classList.remove('tsgc-btn--light');
        var t = form.closest('.tsgc-summary') && form.closest('.tsgc-summary').querySelector('[data-tsgc-routine-title]');
        if (t && t.dataset.tsgcOriginal) t.textContent = t.dataset.tsgcOriginal;
      }
    });
  }

  /* ---------- Mobile bag bar ---------- */
  function updateBagBar(cart) {
    var bar = document.querySelector('[data-tsgc-bagbar]');
    if (!bar) return;
    bar.hidden = !cart.item_count;
    var count = bar.querySelector('[data-tsgc-bag-count]');
    var total = bar.querySelector('[data-tsgc-bag-total]');
    var fill = bar.querySelector('[data-tsgc-bag-fill]');
    var msg = bar.querySelector('[data-tsgc-bag-msg]');
    var p = shippingProgress(cart);
    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = formatMoney(cart.total_price);
    if (fill) fill.style.width = p.pct + '%';
    if (msg) msg.textContent = p.remaining <= 0 ? 'Free shipping unlocked' : formatMoney(p.remaining) + ' away from free shipping';
  }

  /* ---------- Goal tabs ---------- */
  function initTabs(root) {
    if (root.dataset.tsgcReady) return;
    root.dataset.tsgcReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      var strip = tab.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCount(el) {
    if (el.dataset.tsgcCounted) return;
    el.dataset.tsgcCounted = '1';
    var raw = el.dataset.tsgcCount || el.textContent;
    var match = raw.match(/^([^0-9]*)([0-9][0-9,]*\.?[0-9]*)(.*)$/);
    if (!match || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var prefix = match[1];
    var target = parseFloat(match[2].replace(/,/g, ''));
    var decimals = (match[2].split('.')[1] || '').length;
    var suffix = match[3];
    var hasComma = match[2].indexOf(',') > -1;
    function render(v) {
      var s = v.toFixed(decimals);
      if (hasComma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      el.textContent = prefix + s + suffix;
    }
    render(0);
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var start = null;
      var duration = 1300;
      function step(ts) {
        if (!start) start = ts;
        var t = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        render(target * eased);
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      }
      requestAnimationFrame(step);
    }, { threshold: 0.4 });
    io.observe(el);
  }

  /* ---------- Boot ---------- */
  function boot() {
    document.querySelectorAll('[data-tsgc-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-tsgc-count]').forEach(initCount);
    if (document.querySelector('form[data-tsgc-routine], [data-tsgc-bagbar]')) {
      getCart().then(function (cart) { updateRoutines(cart); updateBagBar(cart); }).catch(function () {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  window.TSGC = { getCart: getCart, addItems: addItems, openDrawer: openDrawer, formatMoney: formatMoney };
})();
